export default __webpack_public_path__ + "static/media/Animale_desktop_banner_3.fda4c0c5.png";